const { Validator } = require('jsonschema');
const _ = require('lodash');
const formatters = require('../formatters');
const { common: commonSchemas } = require('../schema');

/**
 * Validates a value matches a schema
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name schema
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }
  const { schema, formatter, opts } = context;
  if (schema === undefined) {
    throw new Error('no-schema');
  }
  const validator = new Validator();
  // add in any common schemas
  _.forEach(commonSchemas, (commonSchema) => {
    if (_.has(commonSchema, 'id')) {
      const { id } = commonSchema;
      validator.addSchema(commonSchema, id);
    }
  });

  const customErrorMessages = {
    'object-id': {
      pattern: "The 'id' field must be a valid object ID.",
    },
  };
  schema.vErrors = customErrorMessages['object-id'];
  const res = validator.validate(value, schema, opts);
  const errors = res.errors.length > 0 ? res.errors : null;

  if (errors) {
    // filter the errors, if nested errors are on, we can exclude the subschema messages
    const filterErrors = () => {
      if (_.has(opts, 'nestedErrors') && opts.nestedErrors === true) {
        return _.filter(errors, (e) => {
          const {
            message,
          } = e || {};
          return !_.some(['does not match allOf schema', '[subschema'], excludePhrase => (message || '').includes(excludePhrase))
        });
      }
      return errors;
    }
    // eradicate some common unnecessary items
    const errorsToUse = filterErrors();
    if (formatter) {
      return Promise.resolve(formatters(formatter, errorsToUse));
    }
    return Promise.resolve(errorsToUse);
  }
  return Promise.resolve(null);
}

module.exports = validate;
